<template>
  <div class="flex-col justify-start group">
    <div class="flex-col">
      <div class="flex-row justify-between items-center group_1">
        <div class="flex-row items-center">
          <div class="shrink-0 section"></div>
          <span class="font text_3 ml-7">虫情监测</span>
        </div>
        <div
          class="flex-row items-center group_3"
          @click="handleClickDays(true)"
        >
          <span class="font_2 text_4">{{ daysText }}</span>
          <img
            class="shrink-0 image_4 ml-34"
            src="https://ide.code.fun/api/image?token=668e9c061a1c620011867e04&name=64b1723bc3ae5e092cd7e4c76eaa17ab.png"
          />
        </div>
      </div>
      <div class="flex-col group_2 view">
        <div class="flex-row items-center self-stretch group_4">
          <img class="image_5" src="../../../assets/images/cq_tongji.png" />
          <span class="font ml-13">虫情统计</span>
        </div>
        <div class="flex-col self-center section_2">
          <div class="echartsWrap" id="echartsWrap"></div>
        </div>
      </div>

      <div class="flex-row items-center group_2 view_2">
        <img class="image_5" src="../../../assets/images/cq_qushi.png" />
        <span class="font text_6 ml-13">虫情趋势</span>
      </div>
      <div class="flex-row group_6">
        <div class="echartsWrap" id="echartsWrap2"></div>
      </div>

      <div class="flex-row items-center group_2 view_7">
        <img class="image_5" src="../../../assets/images/cq_lishi.png" />
        <span class="font text_14 ml-13">识别历史</span>
      </div>
      <div class="flex-col list group_12">
        <div
          class="flex-row items-center  mt-12"
          v-for="(item, index) in imgList"
          :key="index"
        >
          <img
            class="shrink-0 image_12"
            :src="item.imgUrl"
            @click="handleClick(item.imgUrl)"
          />
          <div class="flex-col items-start flex-1 ml-13  result">
            <div class="font_2 text_15">{{ item.date }}</div>
            <div class="font_6 text_16 result_span">
              识别结果：
              <span
                v-for="(result, rIndex) in item.identifyData"
                :key="`${item.date}_${result.code}`"
                class="font_2 text_17"
              >
                {{ result.name }}({{ result.num }})
                {{ rIndex < item.identifyData.length - 1 ? "," : "" }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showDays" position="bottom">
      <van-picker
        title="时间段"
        :columns="daysOptions"
        @cancel="handleClickDays(false)"
        @confirm="onDaysChange"
        show-toolbar
      />
    </van-popup>
  </div>

  <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="list" :immediate-check="true">
    <div v-for="(item, index) in list" :key="index + 1000">
      <div class="pic">
        <div v-if="pic" class="pic_item" v-for="(pic, _index) in item.picList" :key="_index">
          <ImageProxy :url="pic.imageUrl" :index="index" :_index="_index" :click="()=>handleClick(pic.imageUrl)" />
          <div class="time">{{ pic.dateTime }}</div>
        </div>
        <div v-else class="pic_item"></div>
      </div>
    </div>
  </van-list> -->
</template>

<script>
import { ImagePreview } from "vant";
import moment from "moment";
import echarts from "echarts";

export default {
  data() {
    return {
      show: false,
      id: localStorage.getItem("no"),
      list: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 15,
      isFirst: true,
      oldList: [],
      totalPages: 1,
      showDays: false,
      daysText: "7日",
      daysOptions: ["7日", "15日", "30日"],
      chartsBody: null,
      chartsBody2: null,
      imgList: []
    };
  },

  props: {
    setting: {
      type: Function,
      default: (item, type) => {}
    },
    callback: {
      type: Function,
      default: obj => {}
    },
    hasDeviceChange: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    hasDeviceChange(v) {
      console.log("切换到虫情设备;", v);
      if (v) {
        this.id = localStorage.getItem("no");
        this.page = 1;
        this.totalPages = 1;
        this.list = [];
        this.oldList = [];
        this.isFirst = true;
        this.loading = false;
        this.finished = false;
        this.onLoad();
      }
    },
    refreshing(bl) {
      bl && this.onRefresh();
    }
  },

  mounted() {
    this.chartsBody = echarts.init(document.getElementById("echartsWrap"));
    this.chartsBody.showLoading();

    this.chartsBody2 = echarts.init(document.getElementById("echartsWrap2"));
    this.chartsBody2.showLoading();

    this.getPicture();
  },

  methods: {
    handleClickDays(bl) {
      this.showDays = bl;
    },

    onDaysChange(value) {
      this.daysText = value;
      this.handleClickDays(false);
      this.getPicture();
    },

    async onRefresh() {
      this.page = 1;
      this.totalPages = 1;
      this.list = [];
      this.oldList = [];
      this.isFirst = true;
      this.loading = false;
      this.finished = false;
      this.onLoad();
    },

    // 获取摄像头下的图片列表
    async getPicture(id = this.id) {
      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });
      try {
        const index = this.daysOptions.indexOf(this.daysText);
        const day = index === 0 ? 7 : index === 1 ? 15 : 30;
        const now = moment();
        const sevenDaysAgo = now.clone().subtract(day, "days");
        const oneDayLater = now.clone().add(1, "days");

        this.$api
          .getInsectDataDateTime({
            startDate: sevenDaysAgo.format("YYYY-MM-DD"),
            endDate: oneDayLater.format("YYYY-MM-DD"),
            gatewayNo: id
          })
          .then(res => {
            const { list } = res;
            const staticData = [];
            const dateGroup = {};
            const imgList = [];

            list?.map(item => {
              if (item?.identifyData?.length) {
                const obj = {
                  date: moment(item.createTime).format("YYYY-MM-DD"),
                  imgUrl: item.imgUrl,
                  identifyData: []
                };

                const list = [...item.identifyData];

                list.map(o => {
                  const findIndex = staticData.findIndex(
                    it => it.code === o.code
                  );
                  const findIndex2 = obj.identifyData.findIndex(
                    it => it.code === o.code
                  );

                  if (findIndex > -1) {
                    staticData[findIndex].num =
                      Number(staticData[findIndex].num || 0) + Number(o.num);
                  } else {
                    staticData.push({ ...o });
                  }

                  if (findIndex2 > -1) {
                    obj.identifyData[findIndex2].num =
                      Number(obj.identifyData[findIndex2].num || 0) +
                      Number(o.num);
                  } else {
                    obj.identifyData.push({ ...o });
                  }

                  // 按日期分组  为了柱状图的数据
                  if (item.createTime) {
                    const date = moment(item.createTime).format("YYYY-MM-DD");
                    if (dateGroup[date]) {
                      if (!dateGroup[date][o.name]) dateGroup[date][o.name] = 0;
                      dateGroup[date][o.name] += !Number.isNaN(o.num)
                        ? Number(o.num)
                        : 0;
                    } else {
                      dateGroup[date] = {
                        [o.name]: !Number.isNaN(o.num) ? Number(o.num) : 0
                      };
                    }
                  }
                });

                imgList.push(obj);
              }
            });

            const xData = [];
            const yData = [];
            let count = 0;

            staticData.map(o => {
              count += Number(o.num);
              xData.push(o.name);
              yData.push({ value: o.num, name: o.name });
            });

            this.imgList = [...imgList];
            this.list = [...list];
            this.renderEcharts(xData, yData, count);
            this.renderEchartsOfBar(dateGroup);
          })
          .finally(() => {
            this.$toast.clear();
          });
      } catch (err) {
        this.$toast.clear();
        console.error("error:", err);
      }
    },

    renderEcharts(xData, yData, total) {
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          left: "center",
          data: xData,
          formatter: function(name) {
            const index = xData.indexOf(name);
            let ext = "";
            if (index > -1) {
              const num = yData[index].value;
              console.log("name:", name, index, num, total);
              ext = ((num / total) * 100).toFixed(2);
            }
            return name + (ext ? `：${ext}%` : "");
          }
        },
        series: [
          {
            type: "pie",
            radius: "65%",
            center: ["50%", "40%"],
            selectedMode: "single",
            label: false,
            labelLine: { show: false },
            data: yData
          }
        ],
        grid: {
          top: "10%", // 减少顶部留白
          bottom: "10%" // 减少底部留白
        }
      };

      this.chartsBody.setOption(option);
      this.chartsBody.hideLoading();
    },

    renderEchartsOfBar(data) {
      const xData = Object.keys(data).map(key => key.replaceAll("-", "/"));
      const series = [];

      Object.values(data).map(item => {
        Object.keys(item).map(name => {
          const findIndex = series.findIndex(o => o.name === name);
          if (findIndex > -1) {
            series[findIndex].data.push(item[name]);
          } else {
            series.push({
              name,
              type: "line",
              stack: "Total",
              data: [item[name]],
              smooth: true
            });
          }
        });
      });

      console.log("123123:", xData, series);

      const option = {
        tooltip: { trigger: "axis" },
        grid: {
          top: "3%",
          left: "3%",
          right: "2%",
          bottom: "3%",
          containLabel: true
        },
        // toolbox: { feature: { saveAsImage: {} } },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xData
        },
        yAxis: { type: "value" },
        series
      };

      this.chartsBody2.setOption(option);
      this.chartsBody2.hideLoading();
    },

    // 下拉请求数据
    async onLoad() {
      if (!this.id) return;
      this.loading = true;
      if (this.isFirst) {
        await this.getPicture();
      } else {
        this.page <= this.totalPages && (await this.getPicture());
      }
      this.loading = false;
      console.log(
        "this.page :",
        this.page,
        this.totalPages,
        this?.list?.length
      );
      if (
        this.page > this.totalPages ||
        (this.page == 1 && !this?.list?.length)
      ) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    },

    handleClick(url) {
      ImagePreview([url]);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../codeFunCommon.scss";

.ml-7 {
  margin-left: 7px;
}

.mt-57 {
  margin-top: 57px;
}

.ml-13 {
  margin-left: 13px;
}

.mt-19 {
  margin-top: 19px;
}

.group {
  overflow-y: auto;

  .group_1 {
    padding: 0 9.5px;

    .section {
      background-image: linear-gradient(180deg, #56a0fb 0%, #3776f6 100%);
      border-radius: 20px;
      width: 4px;
      height: 15px;
    }

    .text_3 {
      font-weight: 700;
      line-height: 15px;
    }

    .group_3 {
      padding: 11.5px 12px 11px;
      border-radius: 4px;
      height: 37px;
      border: solid 1px #4778e7;

      .text_4 {
        margin-left: 21.5px;
        color: #4778e7;
        font-weight: 700;
        line-height: 12.5px;
      }

      .image_4 {
        width: 10px;
        height: 7px;
      }
    }
  }

  .group_2 {
    padding: 0 10px;

    .group_4 {
      padding-bottom: 12.5px;
    }

    .section_2 {
      width: 100%;

      .image_6 {
        width: 71px;
        height: 100px;
      }

      .image_7 {
        margin-left: 29.5px;
      }

      .image_8 {
        width: 100px;
        height: 71px;
      }

      .pos {
        position: absolute;
        left: 0;
        bottom: 0;
      }

      .group_5 {
        padding-bottom: 29px;
        width: 100.5px;

        .pos_2 {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }

    .image_5 {
      border-radius: 17px;
      width: 30px;
      height: 30px;
    }

    .text_6 {
      line-height: 15px;
    }

    .text_14 {
      line-height: 14.5px;
    }
  }

  .view {
    margin-top: 15.5px;
  }

  .font {
    font-size: 16px;
    font-family: PingFang SC;
    line-height: 15px;
    color: #333333;
  }

  .grid {
    margin-top: 3px;
    height: 68px;
    display: grid;
    grid-template-rows: repeat(2, minmax(0, 1fr));
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 0;
    column-gap: 0;

    .grid-item {
      padding: 10.5px 19px 10.5px;

      .text_5 {
        line-height: 12.5px;
      }
    }

    .grid-item_2 {
      padding: 10.5px 19px 10.5px;

      .text_1 {
        line-height: 12.5px;
      }
    }

    .image_9 {
      width: 12px;
      height: 12px;
    }

    .font_3 {
      font-size: 14px;
      font-family: PingFang SC;
      line-height: 13px;
      color: #000000;
    }

    .grid-item_3 {
      padding: 10.5px 19px 10.5px;

      .text_24 {
        line-height: 12.5px;
      }
    }
  }

  .view_2 {
    margin-top: 6px;
  }

  .group_6 {
    margin-top: 14px;

    .group_9 {
      margin: 4px 0 2.5px;
      width: 18px;

      .font_4 {
        font-size: 12px;
        font-family: PingFang SC;
        line-height: 9px;
        color: #333333;
      }

      .text_7 {
        line-height: 8.5px;
      }

      .text_8 {
        line-height: 8.5px;
      }
    }

    .group_7 {
      border-bottom: solid 1px #e6e9ed;

      .group_8 {
        padding: 7.5px 0 29.5px;
        border-bottom: solid 1px #e6e9ed;

        .view_3 {
          margin-left: 3.5px;
        }

        .pos_3 {
          position: absolute;
          left: 12.5px;
          right: 263px;
          top: 0;
        }
      }

      .group_10 {
        margin-top: -27px;
        padding: 56.5px 0 30px;

        .view_4 {
          margin-right: 3.5px;
        }

        .view_5 {
          margin-right: 3.5px;
          margin-top: 29.5px;
        }

        .view_6 {
          margin-right: 3.5px;
          margin-top: 29.5px;
        }

        .section_4 {
          background-color: #f3f3f3;
          border-radius: 5px;
          width: 31px;

          .section_5 {
            background-color: #5776f2;
            height: 23px;
          }

          .section_8 {
            background-color: #ffaa00;
            height: 49px;
          }

          .section_14 {
            background-color: #36aff5;
            height: 27px;
          }

          .section_7 {
            background-color: #5776f2;
            height: 36px;
          }

          .image_10 {
            width: 31px;
            height: 67px;
          }

          .section_16 {
            background-color: #a46bff;
            height: 28px;
          }
        }

        .pos_4 {
          position: absolute;
          left: 50%;
          top: 0;
          transform: translateX(-50%);
        }

        .pos_6 {
          position: absolute;
          left: 76.5px;
          top: 17px;
        }

        .section_10 {
          padding-top: 18px;
          background-color: #ffaa00;
          width: 31px;

          .section_13 {
            background-color: #36aff5;
            height: 34px;
          }
        }

        .pos_9 {
          position: absolute;
          right: 71.5px;
          top: 47px;
        }

        .section_15 {
          background-color: #a46bff;
          height: 49px;
        }

        .section_6 {
          background-color: #5776f2;
          height: 34px;
        }

        .pos_5 {
          position: absolute;
          left: 204px;
          right: 71.5px;
          top: 13.5px;
        }

        .image_11 {
          border-radius: 5px;
          width: 31px;
          height: 76px;
        }

        .pos_11 {
          position: absolute;
          right: 8px;
          bottom: 0;
        }

        .pos_8 {
          position: absolute;
          left: 267.5px;
          right: 8px;
          top: 34.5px;
        }

        .section_9 {
          background-color: #ffaa00;
          height: 37px;
        }

        .pos_7 {
          position: absolute;
          left: 12.5px;
          right: 263px;
          top: 25px;
        }

        .section_11 {
          background-color: #a46bff;
          width: 31px;

          .section_12 {
            background-color: #36aff5;
            height: 20px;
          }

          .section_17 {
            background-color: #a46bff;
            height: 9px;
          }
        }

        .pos_10 {
          position: absolute;
          left: 12.5px;
          top: 62px;
        }
      }

      .divider {
        background-color: #e6e9ed;
        height: 1px;
      }

      .section_3 {
        background-color: #5776f2;
        height: 37px;
      }
    }
  }

  .group_11 {
    margin-top: 13px;
    padding-left: 52px;
    padding-right: 23px;

    .font_5 {
      font-size: 12px;
      font-family: Inter;
      letter-spacing: -0.5px;
      line-height: 11px;
      color: #808d9e;
    }

    .text_9 {
      font-size: 12.5px;
    }

    .text_10 {
      font-size: 12.5px;
    }

    .text_11 {
      font-size: 12.5px;
    }

    .text_12 {
      font-size: 12.5px;
    }

    .text_13 {
      font-size: 12.5px;
    }
  }

  .view_7 {
    margin-top: 19px;
  }

  .list {
    overflow-x: hidden;

    &:first-child {
      margin-top: 0;
    }

    .image_12 {
      border-radius: 5px;
      width: 124px;
      height: 80px;
    }

    .text_15 {
      line-height: 13px;
    }

    .font_6 {
      font-size: 14px;
      font-family: PingFang SC;
      line-height: 13px;
      color: #505e82;
    }

    .text_16 {
      margin-top: 20.5px;
    }

    .text_17 {
      margin-top: 10px;
    }
  }

  .group_12 {
    margin-left: 10.5px;
    margin-top: 13px;
  }

  .font_2 {
    font-size: 14px;
    font-family: PingFang SC;
    line-height: 13px;
    color: #333333;
  }

  .image_13 {
    width: 100vw;
    height: 21.0587vw;
  }
}

.echartsWrap {
  width: 100%;
  height: 300px;
}

.result {
  height: 80px;
  justify-content: space-between;
  padding: 10px 0;

  .result_span {
    line-height: 16px !important;
    margin-top: 10px !important;
  }
}
</style>
